/**
 * Motion tokens — durations + easing, verbatim from source.
 * Keyframe animations (slidein/slideup/fadein/spin) live in the web global
 * stylesheet and are applied via className helpers (.t-anim-*) on web.
 */
export const motion = {
  tFast: 100,
  tBase: 180,
  easeOut: 'cubic-bezier(0.2,0.8,0.2,1)',
} as const;

/** className helpers for the keyframe animations defined in web/index.html. */
export const animClass = {
  slideIn: 't-anim-slidein',
  slideUp: 't-anim-slideup',
  fadeIn: 't-anim-fadein',
  spin: 't-anim-spin',
} as const;

export type Motion = typeof motion;
